//This service will change
//ng-repeat="match in matches track by $index"
//to
//ng-repeat="match in matches track by match.model.<some_property_or_function>"
//in the typeahead popup template (typeahead-popup.html)

//This allows us to use one time bindings in a typeahead template without running into issues
//where some bindings don't change even when the list changes

//it uses the 'ap-typeahead-track-by' attribute that I defined
//if this attribute isn't used, then it will just use the default of track by $index

//Example Usage:
//uib-typeahead="item for item in getItem($viewValue)"
//ap-typeahead-track-by="Id"
//===============================
//this means 'track by item.Id'

//uib-typeahead="item for item in getItem($viewValue)"
//ap-typeahead-track-by="name"
//================================
//this means 'track by item.name'

// This is hacky but there is no other way right now to do it

angular.module('aprima-core-ui').factory('enableTypeaheadTrackBy', ['findTypeahead', function (findTypeahead) {
    'use strict';

    // the new attribute I'm defining to allow a different track by clause in the inner ng-repeat
    var typeaheadTrackBy = 'ap-typeahead-track-by';

    return enableTypeaheadTrackBy;

    function enableTypeaheadTrackBy(popupElement, typeaheadElement) {
        if(!popupElement) {
            return;
        }

        typeaheadElement = typeaheadElement || findTypeahead(popupElement);
        if(!typeaheadElement) {
            return;
        }
        
        var trackByAttr = typeaheadElement.attr(typeaheadTrackBy);
        if(trackByAttr) {
            popupElement.children('[ng-repeat*="matches"]').first().attr('ng-repeat', function(index, value) {
                if(value) {
                    var nameOfIterator = value.substring(0, value.indexOf(' '));
                    //Will need to update this if the structure of the match changes
                    //(It currently looks something like this { id: 'someid', model: {}, label: {}}
                    return value.replace('$index', nameOfIterator + '.model.' + trackByAttr);
                }
            });
        }
    }
}]);
